import { EGroupedItemsType } from '~/src/services/properties';

export const imageConfig = {
    label: {
        name: 'label',
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            content: {
                name: 'content',
                order: 1,
                label: 'Адрес изображения:',
                type: EGroupedItemsType.File,
            },
            webp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            alt: {
                name: 'alt',
                order: 2,
                label: 'Alt-текст:',
                type: EGroupedItemsType.String,
            },
            customStyles: {
                name: 'customStyles',
                order: 3,
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                withBreakpoints: true,
            },
            customize: {
                name: 'customize',
                label: 'Настройки изображения',
                order: 4,
                items: {
                    width: {
                        name: 'width',
                        label: 'Ширина:',
                        type: EGroupedItemsType.String,
                    },
                    height: {
                        name: 'height',
                        label: 'Высота:',
                        type: EGroupedItemsType.String,
                    },
                    justifyContent: {
                        name: 'justifyContent',
                        label: 'Выравнивание:',
                        type: EGroupedItemsType.TextAlignment,
                    },
                    placement: {
                        name: 'placement',
                        label: 'Разместить',
                        type: EGroupedItemsType.Select,
                    },
                },
            },
            offsetY: {
                name: 'offsetY',
                order: 4,
                label: 'Смещение сверху:',
                type: EGroupedItemsType.String,
                withBreakpoints: true,
            },
            offsetX: {
                name: 'offsetY',
                order: 4,
                label: 'Смещение справа:',
                type: EGroupedItemsType.String,
                withBreakpoints: true,
            },
        },
    },
};
